export const scrollPosition = {
    onChangeScroll: (store, payload) => {
      store.setState({ scrollPosition: payload });
    },
  };